import { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { Terminal } from 'lucide-react';

const LINES = [
  { prompt: '01', text: 'Privacy is sovereignty.' },
  { prompt: '02', text: 'Identity is not a prerequisite for thought.' },
  { prompt: '03', text: 'Financial privacy is personal privacy.' },
  { prompt: '04', text: 'Ownership without autonomy is incomplete.' },
  { prompt: '05', text: 'Cryptography gives individuals agency.' },
  { prompt: '06', text: 'Systems deserve scrutiny, not blind trust.' },
  { prompt: '07', text: 'Physical objects can carry digital ideas.' },
  { prompt: '08', text: 'Art can conceal as much as it reveals.' },
  { prompt: '09', text: 'Some things are meant to be discovered.' },
];

export function PhilosophySection() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-80px' });

  return (
    <section id="principles" className="py-32 px-6 relative overflow-hidden" data-testid="philosophy-section" ref={ref}>
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-[#FFC700]/20 to-transparent" />
      <div className="absolute inset-0 terminal-bg-pattern opacity-3 pointer-events-none" />

      <div className="max-w-3xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.7 }}
          className="mb-16"
        >
          <span className="mono-tag">// SECTION_04 :: PRINCIPLES</span>
          <h2 className="section-title mt-4">
            GUIDING<br /><span className="text-[#FFC700]">PRINCIPLES</span>
          </h2>
        </motion.div>

        <div className="terminal-panel" data-testid="philosophy-content">
          <div className="terminal-panel-header">
            <span className="terminal-panel-dot" />
            <Terminal size={11} />
            ZATO::PRINCIPLES_v1.0
            <span className="ml-auto opacity-40">READ-ONLY</span>
          </div>
          <div className="philosophy-lines p-4">
          {LINES.map((line, i) => (
            <motion.div
              key={line.prompt}
              initial={{ opacity: 0, x: -20 }}
              animate={isInView ? { opacity: 1, x: 0 } : {}}
              transition={{ duration: 0.5, delay: 0.3 + i * 0.06 }}
              className="philosophy-line"
              data-testid={`philosophy-line-${i}`}
            >
              <span className="philosophy-prompt">{line.prompt}</span>
              <p className="philosophy-text">{line.text}</p>
            </motion.div>
          ))}
          </div>
        </div>
      </div>
    </section>
  );
}
